import { jsx as n, jsxs as c } from "react/jsx-runtime";
import { c as i } from "../../../clsx-OuTLNxxd.js";
import { I as r } from "../../../icon-B72I4fRl.js";
import "../icon/iconsList.js";
const _ = "_stepper_j6n29_29", d = "_horizontal_j6n29_33", p = "_vertical_j6n29_38", e = {
  stepper: _,
  horizontal: d,
  vertical: p,
  "step-container": "_step-container_j6n29_43",
  "step-number": "_step-number_j6n29_58",
  "is-disabled": "_is-disabled_j6n29_72",
  "is-done": "_is-done_j6n29_77",
  "step-label": "_step-label_j6n29_82",
  "step-connector": "_step-connector_j6n29_102",
  "dialog-overlay-show": "_dialog-overlay-show_j6n29_1",
  "dialog-content-show": "_dialog-content-show_j6n29_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_j6n29_1"
};
function v({ steps: t, orientation: a = "vertical", className: l }) {
  return /* @__PURE__ */ n("div", { className: i(l, e.stepper, e[a]), children: t.map((s, o) => /* @__PURE__ */ c("div", { className: e["step-container"], children: [
    /* @__PURE__ */ n(
      "span",
      {
        className: i(
          e["step-number"],
          s.isDisabled && e["is-disabled"],
          s.isDone && e["is-done"]
        ),
        children: s.isDone ? /* @__PURE__ */ n(r, { name: "check", color: "success", size: "medium" }) : o + 1
      }
    ),
    /* @__PURE__ */ n(
      "span",
      {
        className: i(
          e["step-label"],
          s.isDone && e["is-done"],
          s.isDisabled && e["is-disabled"]
        ),
        children: s.content
      }
    ),
    (o < t.length - 1 || a === "vertical") && /* @__PURE__ */ n("div", { className: e["step-connector"] })
  ] }, `step-${o + 1}`)) });
}
export {
  v as ProgressSteps
};
